// extracted by mini-css-extract-plugin
export var button = "_p8-0";